import axios from "axios";
import { BACKEND_URL, DataActionType } from "../constants";
import { IDataActions } from "../types";

export async function getUserLinks(dispatch: Function) {
    try {
        const response = await axios.post(BACKEND_URL+"/data/getlinks");
        if (!response.data.error) {
            dispatch({type: DataActionType.UPDATE_DATA, payload: response.data.data});
        } else {
            return [];
        }
    } catch(err) {
        return [];
    }
}

export function extractURLDomain(url: string): string {
    
    let hostname;

    if (url.indexOf("//")>-1) {
        hostname = url.split("//")[1].split("/")[0];
    } else {
        hostname = url.split("/")[0];
    }

    return hostname;
}

export async function deleteLink(userDataDispatch: Function, linkid: string, categoryid: string): Promise<boolean> {
    try {
        const response = await axios.post(BACKEND_URL+"/data/deletelink", {categoryid, linkid});
        if (!response.data.error) {
            const action: IDataActions = {
                type: DataActionType.UPDATE_DATA,
                payload: response.data.data
            }

            userDataDispatch(action);

            return true;
        }

        return false;
    } catch(err) {
        return false;
    }
}

export async function deleteCategory(userDataDispatch: Function, categoryid: string): Promise<boolean> {
    try {

        const response = await axios.post(BACKEND_URL+"/data/deleteCategory", { categoryid });

        if (!response.data.error) {
            const action: IDataActions = {
                type: DataActionType.UPDATE_DATA,
                payload: response.data.data,
            }

            userDataDispatch(action);

            return true;
        }

        return false;

    } catch(err) {
        return false;
    }
}